module.exports = __webpack_public_path__ + "static/media/puck.08cfe6ad.png";